<template lang="pug">
.discount-container
  .rule(@click="goRule") 规则
  .banner
  .operation.flex-mid
    template(v-if="loading")
      .text 加载中
    template(v-else)
      .text
        template(v-if="enrolled")
          span 您已享受
          span.red {{ discountInfo.count }}次
          span 随机立减 共优惠
          span.red {{ discountInfo.save }}元
        template(v-else)
          template(v-if="!haveAnyCard")
            span 哈啰APP限时特惠骑行活动
          template(v-if="card.bike && !haveBothCard")
            span 哈啰APP骑助力车限时特惠活动
          template(v-if="card.ebike && !haveBothCard")
            span 哈啰APP骑单车限时特惠活动
          template(v-if="haveBothCard")
            span 抱歉，您暂无活动参与资格
      .btn.flex-mid(@click="clickBtn") {{ btnText }}
  .desc
    .part
      .title 1.什么是APP随机立减活动？
      .content APP随机立减活动是针对哈啰APP推出的限时优惠活动。是指当您在APP中完成骑行订单后，哈啰将随机为您的订单减免一定的订单金额，最高可享免费骑行。
    .part
      .title 2.随机立减活动最高能减免多少钱？
      .content 随机立减金额完全随机，没有最高额度的限制，最高减免金额不超过您实际需要支付的金额，最高享免单骑行哦。
    .part
      .title 3.为什么我参与了随机立减活动但我的骑行订单没有减钱？
      .content 因为随机立减仅支持在APP骑行中使用，因此无法对在支付宝中产生的订单进行随机的费用减免。下载APP出行更优惠哦。
  Dialog(:show="dialog", @cancel="cancel", @ok="ok")
    template(v-if="!haveAnyCard")
      span 恭喜您成功领取到APP随机立减福利，
      span.red 骑单车、助力车
      span 首单最高可享免单，快去哈啰APP享受优惠出行吧！
    template(v-if="card.bike")
      span 恭喜您成功领取到APP随机立减福利，
      span.red 骑助力车
      span 首单最高可享免单，快去哈啰APP享受优惠出行吧！
    template(v-if="card.ebike")
      span 恭喜您成功领取到APP随机立减福利，
      span.red 骑单车
      span 首单最高可享免单，快去哈啰APP享受优惠出行吧！
</template>

<script>
import { env } from '@hb/NBridge/lib/h5';
import Toast from '@/components/toast';
import { startApp } from '@/utils/index';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import {
  getCommonConfig,
  getUserBikeCards,
  enrollActicity,
  getUserEbikeCards,
  getUserAndActivityInfo,
} from '@/api/discount';
import Dialog from './components/dialog';
import { getTokenAndKey, isPreRender } from '../../utils/index';

const MP_SCHEMA = `alipays://platformapi/startapp?appId=2017050407110255&page=%2Fpages%2Findex%2Findex&query=redirectUrl%3D${encodeURIComponent(
  window.location.href,
)}`;
const APP_DOWNLOAD_LINK = 'https://m.hellobike.com/ebike-h5/latest/index.html#/activity/common?guid=46efb2fcb9354f69825277473fa83816&beyondMP=true';

export default {
  components: {
    Dialog,
  },
  data() {
    return {
      dialog: false,
      activityIds: [],
      user: {
        token: '',
        ticket: '',
      },
      card: {
        ebike: false,
        bike: false,
      },
      loading: true,
      enrolled: false,
      activities: [],
    };
  },
  computed: {
    login() {
      return !!this.user.token;
    },
    haveAnyCard() {
      return this.card.bike || this.card.ebike;
    },
    haveBothCard() {
      return this.card.bike && this.card.ebike;
    },
    discountInfo() {
      const data = this.activities.reduce(
        (res, cur) => {
          res.count += cur.totalJoinCount;
          res.save += cur.totalPromoAmount;
          return res;
        },
        { count: 0, save: 0 },
      );
      data.save = Math.round(data.save * 100) / 100;
      return data;
    },
    btnText() {
      if (!this.login) {
        return '登录参与活动';
      }
      if (this.enrolled) {
        if (env.isEasyBikeApp) {
          return '去骑行';
        }
        return '去APP骑行';
      }
      if (!this.haveBothCard) {
        return '立即参与';
      }
      if (env.isEasyBikeApp) {
        return '去骑行';
      }
      return '去APP骑行';
    },
  },
  async mounted() {
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      return;
    }
    UBT.pageView({
      pageId: 'platform_reduction',
      categoryId: 'platform',
      businessInfo: {
        adsource: this.$route.query.adsource,
      },
    });
    await this.initUser();
    this.biz();
  },
  methods: {
    cancel() {
      this.dialog = false;
      UBT.clickButton({
        pageId: 'platform_reduction',
        buttonName: 'platform_wait',
        categoryId: 'platform',
        businessInfo: {
          businessType: this.getBusinessType(),
        },
      });
    },
    getBusinessType() {
      if (env.isEasyBikeApp) {
        return '0';
      }
      if (env.isAliMP || env.isAliMPMonitor) {
        return '1';
      }
      return 'h5';
    },
    getBusinessTypeV2() {
      let i;
      if (!this.haveAnyCard) {
        i = 0;
      }
      if (this.card.bike) {
        i = 1;
      }
      if (this.card.ebike) {
        i = 2;
      }
      if (env.isAliMP || env.isAliMPMonitor) {
        i += 3;
      }
      return i;
    },
    clickBtn() {
      if (this.btnText === '去骑行' || this.btnText === '去APP骑行') {
        UBT.clickButton({
          pageId: 'platform_reduction',
          buttonName: 'platform_go',
          categoryId: 'platform',
          businessInfo: {
            businessType: this.getBusinessType(),
          },
        });
      }
      if (this.btnText === '立即参与') {
        UBT.clickButton({
          pageId: 'platform_reduction',
          buttonName: 'platform_sign',
          categoryId: 'platform',
          businessInfo: {
            businessType: this.getBusinessTypeV2(),
          },
        });
      }
      if (!this.login) {
        if (env.isEasyBikeApp || env.isAliMP || env.isAliMPMonitor) {
          this.initUser();
        } else {
          this.goMP();
        }
        return;
      }
      if (this.enrolled) {
        this.goApp();
        return;
      }
      if (!this.haveBothCard) {
        this.enroll();
      } else {
        this.goApp();
      }
    },
    enroll() {
      if (!this.login) {
        Toast.show('请先登录');
      }
      if (!this.activityIds || this.activityIds.length === 0) {
        Toast.show('未找到对应活动');
        return;
      }
      enrollActicity({
        activityIds: this.activityIds,
        ...this.user,
      })
        .then((v) => {
          if (v && v.data) {
            const success = v.data.filter((i) => i.applyResult === 1).length > 0;
            if (success) {
              UBT.moduleExpose({
                pageId: 'platform_reduction',
                categoryId: 'platform',
                moduleId: 'platform_pop',
                contentId: 'platform_pop',
                exposureTimes: '1',
                businessInfo: {
                  businessType: this.getBusinessType(),
                },
              });
              this.dialog = true;
              this.enrolled = true;
            } else {
              Toast.show('服务异常，请稍后再试');
            }
          }
        })
        .catch((e) => Toast.showError(e));
    },
    goApp() {
      if (env.isEasyBikeApp) {
        window.location.href = 'hellobike://hellobike.com/scan_qr';
      } else if (env.isAliMP || env.isAliMPMonitor) {
        startApp(APP_DOWNLOAD_LINK);
      } else {
        window.location.href = APP_DOWNLOAD_LINK;
      }
    },
    goMP() {
      window.location = MP_SCHEMA;
      setTimeout(() => {
        window.location.href = APP_DOWNLOAD_LINK;
      }, 300);
    },
    initUser() {
      return getTokenAndKey()
        .then((v) => {
          const { token, ticket } = v;
          this.user.token = token;
          this.user.ticket = ticket;
          return v;
        })
        .catch(() => ({}));
    },
    ok() {
      UBT.clickButton({
        pageId: 'platform_reduction',
        buttonName: 'platform_use',
        categoryId: 'platform',
        businessInfo: {
          businessType: this.getBusinessType(),
        },
      });
      this.goApp();
      this.dialog = false;
    },
    goRule() {
      UBT.clickButton({
        pageId: 'platform_reduction',
        buttonName: 'platform_rule',
        categoryId: 'platform',
        businessInfo: {},
      });
      window.location.href = 'https://m.hellobike.com/ebike-h5/latest/article.html?guid=9f8a2fc32ce345b0bc6136e8fe36737b';
    },
    async biz() {
      if (!this.login) {
        this.loading = false;
        return;
      }
      const req1 = Promise.all([
        getUserEbikeCards(this.user)
          .then((v) => {
            if (!v || !v.data || !v.data.myCard) {
              return false;
            }
            return v.data.myCard.length !== 0;
          })
          .catch(() => false),
        getUserBikeCards(this.user)
          .then((v) => {
            if (!v || !v.data) {
              return false;
            }
            return v.data.userStatus === 2;
          })
          .catch(() => false),
      ]).then(([ebike, bike]) => {
        this.card.ebike = ebike;
        this.card.bike = bike;
      });
      const activityIds = await getCommonConfig(this.user)
        .then((v) => {
          if (!v || !v.data || !v.data.randomReduction) {
            return [];
          }
          return v.data.randomReduction.activityIds || [];
        })
        .catch((e) => Toast.showError(e));
      this.activityIds = activityIds;
      const req2 = getUserAndActivityInfo({
        activityIds,
        ...this.user,
      }).then((v) => {
        if (v && v.data) {
          this.activities = v.data || [];
          this.enrolled = (v.data || []).filter((item) => item.status === 2).length > 0;
        }
      });
      await Promise.all([
        req1, req2,
      ]).catch(() => {});
      this.loading = false;
      (() => {
        let i;
        if (this.btnText === '立即参与') {
          i = 0;
        }
        if (this.btnText === '去骑行' || this.btnText === '去APP骑行') {
          i = 1;
        }
        if (env.isAliMP || env.isAliMPMonitor) {
          i = (i || 0) + 2;
        }
        UBT.moduleExpose({
          pageId: 'platform_reduction',
          categoryId: 'platform',
          moduleId: 'platform_activity',
          contentId: 'platform_activity',
          exposureTimes: '1',
          businessInfo: {
            businessType: i,
          },
        });
      })();
    },
  },
};
</script>

<style lang="less" scoped>
.discount-container {
  background-color: #ff9e00;
  height: 100%;
  padding-bottom: 0.56rem;
  overflow: auto;
  position: relative;

  .rule {
    position: absolute;
    right: 0;
    top: 0.15rem;
    width: 0.45rem;
    height: 0.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ff5900;
    border-radius: 0.5rem 0 0 0.5rem;
    font-size: 0.12rem;
    color: rgba(255, 255, 255, 1);
  }

  .banner {
    width: 100%;
    height: 3.75rem;
    background-size: 100% 100%;
    background-image: url(https://m.hellobike.com/resource/AppPlatformH5/common/QSEJiBKTW46C1Q0a3QrlO.png);
  }

  .operation {
    margin: 0 0.25rem;
    margin-top: -0.6rem;
    padding: 0.3rem 0;
    background: #fff;
    border-radius: 0.08rem;
    min-height: 1.6rem;
    flex-direction: column;

    .text {
      font-size: 0.18rem;
      color: #333;
      line-height: 0.25rem;
      text-align: center;
      white-space: nowrap;

      .red {
        color: rgba(254, 56, 34, 1);
      }
    }

    .btn {
      width: 2.5rem;
      height: 0.41rem;
      background: linear-gradient(129deg, #fe552c 0%, #fe3622 100%);
      border-radius: 0.21rem;
      font-size: 0.18rem;
      font-weight: 500;
      color: #fff;
      margin-top: 0.19rem;
    }
  }

  .desc {
    padding: 0 0.25rem;
    margin-top: 0.3rem;
    color: white;
    line-height: 0.25rem;

    .part {
      margin-bottom: 0.17rem;

      .title {
        font-size: 0.17rem;
        font-weight: 500;
      }

      .content {
        font-size: 0.13rem;
      }
    }
  }
}
</style>
